import { type CSSProperties, type FC } from "react";

import ListCellContent, { type ListCellItem } from "./ListCellContent.js";
import { TableCell } from "./TableCell.js";
import { type Organism } from "@/graphql.ts";
import { nonBreakingSpace } from "@/settings/settings.js";
import { type IAgGridCellProps } from "@/ui-modules/core/grid/cell-base-interfaces.ts";

interface IOrganismCellProps {
  style?: CSSProperties;
  classname?: string;
  tooltip?: string;
}

/**
 * Converts an organism into {@link ListCellItem}s.
 */
const TableCellOrganism: FC<IAgGridCellProps & IOrganismCellProps> = (props) => {
  if (!props.value) {
    return null;
  }

  const multiValues: Organism[] = props.value instanceof Array ? props.value : [props.value];

  const items: ListCellItem[] = multiValues.map((v) => ({
    value: v == undefined ? nonBreakingSpace : v.name,
    tooltip: props.tooltip || v.name || nonBreakingSpace,
  }));
  return (
    <TableCell>
      <ListCellContent items={items} colDef={props.colDef} style={props.style} context={props.context} />
    </TableCell>
  );
};

export default TableCellOrganism;
